const LogoPrecision = Object.freeze({
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH'
})
export default LogoPrecision
// RESERVE BELOW
